import { useEffect } from 'react';

// Bladeren met de pijltjestoetsen in een venster dat één item uit een lijst
// toont (speler, detail). Typ je in een veld, dan blijven de pijltjes van het
// veld. Escape laat het venster zelf afhandelen (MUI Dialog doet dat al).
const inVeld = (el) => {
  const tag = (el?.tagName || '').toLowerCase();
  return tag === 'input' || tag === 'textarea' || tag === 'select' || Boolean(el?.isContentEditable);
};

export default function useToetsNavigatie({ actief = true, onVorige, onVolgende }) {
  useEffect(() => {
    if (!actief) return undefined;
    const handler = (e) => {
      if (e.metaKey || e.ctrlKey || e.altKey || inVeld(e.target)) return;
      if (e.key === 'ArrowLeft' && onVorige) { e.preventDefault(); onVorige(); }
      else if (e.key === 'ArrowRight' && onVolgende) { e.preventDefault(); onVolgende(); }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [actief, onVorige, onVolgende]);
}
